module.exports = __webpack_public_path__ + "img/130.d3c143d4.jpg";